import React from "react";

interface CornerMarksProps {
  dark?: boolean;
  size?: number;
  className?: string;
}

export function CornerMarks({
  dark = true,
  size = 12,
  className,
}: CornerMarksProps) {
  const color = dark ? "var(--cream-30)" : "var(--charcoal-14)";

  const markStyle = (corner: string): React.CSSProperties => {
    const base: React.CSSProperties = {
      position: "absolute",
      width: size,
      height: size,
      pointerEvents: "none",
    };
    switch (corner) {
      case "tl":
        return { ...base, top: 6, left: 6, borderTop: `1px solid ${color}`, borderLeft: `1px solid ${color}` };
      case "tr":
        return { ...base, top: 6, right: 6, borderTop: `1px solid ${color}`, borderRight: `1px solid ${color}` };
      case "bl":
        return { ...base, bottom: 6, left: 6, borderBottom: `1px solid ${color}`, borderLeft: `1px solid ${color}` };
      case "br":
        return { ...base, bottom: 6, right: 6, borderBottom: `1px solid ${color}`, borderRight: `1px solid ${color}` };
      default:
        return base;
    }
  };

  return (
    <div className={`absolute inset-0 pointer-events-none ${className ?? ""}`} aria-hidden="true">
      <div style={markStyle("tl")} />
      <div style={markStyle("tr")} />
      <div style={markStyle("bl")} />
      <div style={markStyle("br")} />
    </div>
  );
}
